import { getMIMEType, isDataURL, isMimeType } from 'assets/js/helpers/dataUrl';
import { logError } from 'src/utils/logger';

export class DataUrlService {
  log = logError(this.constructor.name);

  createDataUrl (mimeType, data) {
    return `data:${mimeType};base64,${data}`;
  }

  async getMimeType (url, blob) {
    // TODO: remove dependency on helper
    const mimeType = await getMIMEType(url, blob);

    if (!isMimeType(mimeType)) throw new Error('Could not determine MIME type');

    return mimeType;
  }

  isDataURL (url) {
    // TODO: remove dependency on helper
    return isDataURL(url);
  }

  async urlToDataUrl (url, options = { fallbacks: [], maxByteSize: undefined }) {
    try {
      const { mediaType, content } = await this.fetchAsDataUrl(url, options.maxByteSize);

      const dataUrl = this.createDataUrl(mediaType, content);

      if (!this.isDataURL(dataUrl)) {
        throw new Error(`Failed to create data url from ${url}`);
      }

      return dataUrl;
    } catch (error) {
      if (options.fallbacks.length > 0) {
        this.log(error);

        const fallback = options.fallbacks.shift();
        return await this.urlToDataUrl(fallback, options);
      }

      throw error;
    }
  }

  async fetchAsDataUrl (url, maxByteSize) {
    if (maxByteSize) {
      await this.checkValidUrl(url, maxByteSize);
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${url}`);
    }
    const blob = await response.blob();
    const mediaType = await this.getMimeType(url, blob);

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onloadend = () => {
        const result = reader.result;
        const content = result?.toString().split(',').pop();

        resolve({ mediaType, content });
      };
      reader.readAsDataURL(blob);
    });
  }

  async checkValidUrl (url, maxByteSize) {
    // TODO: Backend should provide EP to check
    // image versions without needing to perform a separate HEAD request for each
    const response = await fetch(url, { method: 'HEAD' });
    if (!response.ok) throw new Error(`Failed to fetch ${url}`);

    const contentLength = parseInt(response.headers.get('Content-Length'));
    if (contentLength > maxByteSize) {
      throw new Error(`${url} size exceeds ${maxByteSize} bytes`);
    }
  }
}
